import { Injectable } from '@angular/core';
import { Comments } from '@common/interfaces/comment';
import { CommentStore } from './comment.store';
import { CommentQuery } from './comment.query';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { ID } from '@common/interfaces/id';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { WsACKCallback } from '@common/api/ack';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';

const TOPIC = Topics.ISSUE_COMMENTS;
@Injectable({
  providedIn: 'root'
})
export class CommentService extends CrudService<Comments, CommentStore, CommentQuery> {
  constructor(
    protected store: CommentStore,
    public query: CommentQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService) {
    super(
      TOPIC,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

  populateStore(comments: Comments[]) {
    for (const comment of comments) {
      if (!this.query.getEntity(comment.id)) {
        this.store.add(comment);
      }
    }
  }

  trash(commentId: ID, withMentions: boolean, callback?: WsACKCallback<void>) {
    const dto = { commentId, withMentions };
    this.featureCommandService.send<void>(
      {
        target: 'feature:comment',
        command: 'trash',
        dto,
        ...this.projectIdFromComment(commentId),
      },
      () => this.actionService.sendMessage(TOPIC, 'trash', dto, callback),
      callback,
    );
  }

  trashForLinkedProject(commentId: ID, projectId: string, callback?: WsACKCallback<void>) {
    const dto = { commentId, projectId };
    this.featureCommandService.send<void>(
      {
        target: 'feature:comment',
        command: 'trash-linked-project',
        dto,
        ...this.projectIdFromComment(commentId),
      },
      () => this.actionService.sendMessage(TOPIC, 'trashLinkedByProject', dto, callback),
      callback,
    );
  }

  /*   copyToLinked(commentId: string, typeInterfaceName: string, callback?: WsACKCallback<void>) {
      this.actionService.sendMessage(Topics.ISSUE_COMMENTS, 'copyToLinked', { commentId, typeInterfaceName }, callback);
    }

  copyToLinkedBy(commentId: string, typeInterfaceName: string, callback?: WsACKCallback<void>) {
    this.actionService.sendMessage(Topics.ISSUE_COMMENTS, 'copyToLinkedBy', { commentId, typeInterfaceName }, callback);
  }*/

  copyToLinkedProject(commentId: string, projectId: string, typeInterfaceName: string, callback?: WsACKCallback<void>) {
    const dto = { commentId, typeInterfaceName, projectId };
    this.featureCommandService.send<void>(
      {
        target: 'feature:comment',
        command: 'copy-to-linked-project',
        dto,
        ...this.projectIdFromComment(commentId),
      },
      () => this.actionService.sendMessage(TOPIC, 'copyToLinkedProject', dto, callback),
      callback,
    );
  }

  copyToLinkedByProject(commentId: string, projectId: string, typeInterfaceName: string, callback?: WsACKCallback<void>) {
    const dto = { commentId, typeInterfaceName, projectId };
    this.featureCommandService.send<void>(
      {
        target: 'feature:comment',
        command: 'copy-to-linked-by-project',
        dto,
        ...this.projectIdFromComment(commentId),
      },
      () => this.actionService.sendMessage(TOPIC, 'copyToLinkedByProject', dto, callback),
      callback,
    );
  }

  getAllByCopyOf(commentId: string, callback?: WsACKCallback<Comments[]>) {
    const dto = { commentId };
    this.featureCommandService.send<Comments[]>(
      {
        target: 'feature:comment',
        command: 'get-all-by-copy-of',
        dto,
        ...this.projectIdFromComment(commentId),
      },
      () => this.actionService.sendMessage(TOPIC, 'getAllByCopyOf', dto, callback),
      callback,
    );
  }

  /** Il comando viene eseguito nella scope del progetto del commento, non in quella del progetto collegato. */
  private projectIdFromComment(commentId: ID): { projectId?: string } {
    const projectId = this.query.getEntity(commentId)?.projectId;
    return projectId ? { projectId } : {};
  }

}
